module.exports = new __parcel__URL__("instagram.162a3198.svg").toString();